import { Component, Input } from '@angular/core';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { Time } from '../common-types';

@Component({
  selector: 'date-picker-control',
  templateUrl: './date-picker-control.component.html',
  styleUrls: ['./date-picker-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DatePickerControlComponent,
    multi: true
  }]
})
export class DatePickerControlComponent extends BaseControl {

  @Input() options: IMyOptions = {
    dateFormat: Time.mdbDateFormat,
    startDate: ''
  };
  
  constructor() {
    super();
  }

  ngOnInit() {
  }

  // onWriteValue(value) {

  // }

}
